import { z } from 'zod';

import { httpGetAdapter } from '@/lib/adapters/httpGetAdapter';
import { schoolsResponseSchema, type SchoolsResponse } from '@/schemas/school';

export const getSchoolsParamsSchema = z.object({
  size: z.number().optional(),
  ano: z.string().optional(),
  search: z.string().optional(),
  redeId: z.string().optional(),
});

export type GetSchoolsParams = z.infer<typeof getSchoolsParamsSchema>;

export const getEscolas = httpGetAdapter<SchoolsResponse, GetSchoolsParams>({
  url: '/v2/escolas/logado',
  schema: schoolsResponseSchema,
  mapParams: (params) => ({
    size: params?.size ?? 24,
    ...(params?.search ? { search: params.search } : {}),
    ...(params?.redeId ? { redeId: params.redeId } : {}),
  }),
});
